import AdminPeople from "./AdminPeople";

export default AdminPeople;
